var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRoles)?_c('div',{staticClass:"ml-4"},[_c('a',{staticClass:"ml-2",on:{"click":function($event){return _vm.$router.push('/reports')}}},[_c('a-icon',{attrs:{"type":"pie-chart"}}),_vm._v(" Báo cáo ")],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }